import { render, staticRenderFns } from "./InsuranceMain.vue?vue&type=template&id=33355b04&scoped=true&"
import script from "./InsuranceMain.vue?vue&type=script&lang=ts&"
export * from "./InsuranceMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33355b04",
  null
  
)

export default component.exports